import React from "react";
import PropTypes from "prop-types";
import PrimaryButtonLink from "components/v3/primary-button/PrimaryButtonLink";
import { BUTTON_THEME_WHITE } from "components/v3/primary-button/themes";
import styles from "./styles.module.scss";

const SubscriptionSuccessMessage = (props) => {
    const {
        title = "Congratulations!",
        children,
        callToActionText,
        callToActionLink
    } = props;

    return (
        <div className={ styles.successContainer }>
            <h1 className={ styles.header }>{ title }</h1>
            <p className={ styles.message }>{ children }</p>
            <CallToActionButton
                callToActionText={ callToActionText }
                callToActionLink={ callToActionLink }
            />
        </div>
    );
};

const CallToActionButton = (props) => {
    const {
        callToActionText,
        callToActionLink
    } = props;

    if (!callToActionText && !callToActionLink) {
        return null;
    }

    return (
        <div className={ styles.buttonContainer }>
            <PrimaryButtonLink
                text={ callToActionText }
                theme={ BUTTON_THEME_WHITE }
                to={ callToActionLink }
            />
        </div>
    );
};

SubscriptionSuccessMessage.propTypes = {
    title: PropTypes.string,
    callToActionText: PropTypes.string,
    callToActionLink: PropTypes.string,
    children: PropTypes.node
};

export default SubscriptionSuccessMessage;
